
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import InputFieldMixin from '~/components/Inputs/InputFieldMixin';

@Component
export default class Select extends mixins(InputFieldMixin) {
  @Prop({ default: () => ({ bottom: true, offsetY: true }) }) menuProps!: unknown;

  @Prop({ default: () => [] }) rules!: Array<() => boolean | string>;

  @Prop(Boolean) hideDropdownIcon!: boolean;

  @Prop(Boolean) blurOnClear!: boolean;

  get appendIcon(): string {
    return this.hideDropdownIcon ? '' : '$dropdown';
  }

  get mergedRules() {
    return [this.isRequired, ...this.rules];
  }

  onClear() {
    this.$emit('click:clear');
    if (this.blurOnClear) (this.$refs.select as HTMLElement).blur();
  }
}
